<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card class="p-2" @mousemove="showBtnContent = true" @mouseleave="showBtnContent = false">
		<template slot="actions">
			<div class="flex flex-row justify-between">
				<transition name="fade">
					<vx-tooltip delay=".1s" :text="$t('Crud.Update')">
						<vs-button
							v-show="showBtnContent"
							icon-pack="feather"
							icon="icon-edit"
							color="primary"
							type="flat"
							radius
							@click.stop="editData(item)"
						></vs-button>
					</vx-tooltip>
				</transition>
				<transition name="fade">
					<vx-tooltip delay=".1s" :text="$t('Crud.Delete')">
						<vs-button
							v-show="showBtnContent"
							icon-pack="feather"
							icon="icon-trash-2"
							color="danger"
							type="flat"
							radius
							@click.stop="openConfirm(item.id)"
						></vs-button>
					</vx-tooltip>
				</transition>
				<vs-dropdown vs-trigger-click>
					<vs-button
						icon-pack="feather"
						icon="icon-more-vertical"
						color="primary"
						type="flat"
						radius
					></vs-button>

					<vs-dropdown-menu class="w-64">
						<vs-dropdown-item @click.stop="goToConfig">
							<vx-tooltip delay=".1s" :text="$t('CompanyConfigCrud')" position="bottom">
								<div class="flex items-center mt-2">
									<i class="material-icons"> settings </i>
									<span class="ml-2">{{ $t("Setting.Setting") }}</span>
								</div>
							</vx-tooltip>
						</vs-dropdown-item>
						<vs-dropdown-group :vs-label="''">
							<vs-dropdown-item
								@click="createServiroute(item)"
								v-if="item.has_serviroutes === 0 && item.total_resources > 0"
							>
								<div class="flex items-center">
									<i class="material-icons"> add_box </i>
									<span class="ml-2">{{ $t("Add") }} Serviroutes</span>
								</div>
							</vs-dropdown-item>
							<vs-dropdown-item @click="createSitidata" v-if="item.has_sitidata === 0">
								<div class="flex items-center hover:text-primary stroke-current">
									<i class="material-icons"> add_box </i>
									<span class="ml-2">{{ $t("Add") }} Sitidata</span>
								</div>
							</vs-dropdown-item>
							<vs-dropdown-item @click.stop="createAdminResource(item)" v-if="!item.total_resources">
								<div class="flex items-center hover:text-primary stroke-current">
									<i class="material-icons"> person_add </i>
									<span class="ml-2">{{ $t("Add") + " " + $t("Resource.Resource") }}</span>
								</div>
							</vs-dropdown-item>

							<vs-dropdown-item @click="handleAccessToken">
								<vx-tooltip
									delay=".1s"
									:text="$t('CompanyModule.GenerateAccessToken')"
									position="bottom"
								>
									<div class="flex items-center hover:text-primary stroke-current">
										<i class="material-icons"> vpn_key </i>
										<span class="ml-2">{{ $t("CompanyModule.AccessToken") }}</span>
									</div>
								</vx-tooltip>
							</vs-dropdown-item>
						</vs-dropdown-group>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
		</template>

		<div class="flex items-center justify-center" style="min-height: 150px">
			<img
				v-if="checkImg"
				:src="item.url_logo"
				alt="user-profile-cover"
				class="logo responsive item-center"
				:title="item.description"
				@mouseover="showDescription = true"
				@mouseleave="showDescription = false"
			/>
			<vs-avatar
				v-else
				class="mx-auto mb-6 block font-bold"
				size="120px"
				style="font-size: 30px"
				:title="item.description"
				:text="item.name"
				@mouseover="showDescription = true"
				@mouseleave="showDescription = false"
			/>
		</div>
		<div class="text-center">
			<h5 class="font-medium truncate">{{ item.name }}</h5>
			<p class="text-grey truncate">{{ (item.city + " - " + item.address) | capitalize }}</p>
		</div>
		<vs-divider></vs-divider>

		<div class="flex justify-between flex-wrap mb-4">
			<span>
				<p class="text-xl">{{ $t("Resource.Resources") }}</p>
				<p class="text-grey" v-if="!item.resource_typology_id">{{ item.total_resources }}</p>
				<p class="text-grey" v-if="!item.total_resources">{{ $t("Resource.NotResources") }}</p>
			</span>
			<div>
				<vs-chip v-if="item.has_sitidata" color="success"> Sitidata </vs-chip>
				<vs-chip v-if="item.has_serviroutes" color="success"> Serviroutes </vs-chip>
			</div>
		</div>
		<div class="flex justify-between flex-wrap">
			<span class="w-full">
				<p class="text-xl">{{ $t("ContactPerson") }}</p>
				<p class="text-grey">{{ item.contac_persons }}</p>
			</span>
			<span class="w-full mt-1">
				<p class="text-xl">{{ $t("Phone") }}</p>
				<p class="text-grey">{{ item.phone }}</p>
			</span>
		</div>

		<div class="mb-4 mt-base">
			<div class="flex justify-between">
				<small class="font-semibold">{{ $t("CompanyModule.MissingServiceTime") }}</small>
				<small class="font-semibold text-grey">{{ missingTimeText(missingTime) }}</small>
			</div>
			<vs-progress
				:percent="percentage"
				class="block mt-1 shadow-md"
				:color="percentageColor(percentage)"
			></vs-progress>
		</div>
	</vx-card>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			required: true,
		},
		editData: {
			type: Function,
			required: false,
		},
		openConfirm: {
			type: Function,
			required: false,
		},
		createAdminResource: {
			type: Function,
			required: false,
		},
		createServiroute: {
			type: Function,
			required: false,
		},
		manageAccessToken: {
			type: Function,
			required: false,
		},
	},
	data() {
		return {showDescription: false, showBtnContent: false};
	},
	computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		percentageColor() {
			return function (percent) {
				return percent > 99 ? "danger" : percent >= 0 && percent <= 80 ? "success" : "warning";
			};
		},
		percentage() {
			// Set the start and end dates
			const startDate = new Date(this.item.date_init);
			const endDate = new Date(this.item.date_end);

			// Get the total time difference in milliseconds
			const totalTime = endDate.getTime() - startDate.getTime();

			// Get the time difference from the start date to the current date in milliseconds
			const currentTime = new Date().getTime() - startDate.getTime();

			// Calculate the percentage of time that has elapsed
			const percentElapsed = (currentTime / totalTime) * 100;

			return percentElapsed;
		},
		missingTime() {
			// Set the start and end dates
			const startDate = new Date(this.item.date_init);
			const endDate = new Date(this.item.date_end);

			// Calculate the time difference in milliseconds
			const timeDiff = endDate.getTime() - startDate.getTime();

			// Calculate the number of days between the two dates
			const totalDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

			// Calculate the number of months between the two dates
			const totalMonths = Math.ceil(timeDiff / (1000 * 3600 * 24 * 30.44));

			// Get the current date
			const today = new Date();

			// Calculate the time difference in milliseconds from the start date to today
			const missingTime = endDate.getTime() - today.getTime();

			// Calculate the number of missing days
			const missingDays = Math.ceil(missingTime / (1000 * 3600 * 24));

			// Calculate the number of missing months
			const missingMonths = Math.ceil(missingTime / (1000 * 3600 * 24 * 30.44));

			return {
				totalMonths,
				missingMonths,
				missingDays,
				totalDays,
			};
		},
		missingTimeText() {
			return function (missingTime) {
				if (missingTime.missingDays > 0 && missingTime.missingDays <= 60) {
					const days = missingTime.missingDays;
					return days > 1
						? missingTime.missingDays + " " + this.$t("CompanyModule.Days")
						: missingTime.missingDays + " " + this.$t("CompanyModule.Day");
				} else if (missingTime.missingDays > 60 && missingTime.missingDays <= 365) {
					return missingTime.missingMonths + " " + this.$t("CompanyModule.Months");
				} else if (missingTime.missingDays > 365) {
					const years = missingTime.missingMonths / 12;
					return years > 1
						? years.toFixed(1) + " " + this.$t("CompanyModule.Years")
						: years.toFixed(1) + " " + this.$t("CompanyModule.Year");
				} else if (missingTime.missingDays <= 0) {
					return 0;
				}
			};
		},
		checkImg() {
			return Object.hasOwnProperty.call(this.item, "url_logo") && this.item.url_logo;
		},
	},
	methods: {
		createSitidata() {
			this.$router
				.push({name: "app-setting", params: {company_id: this.item.id, config_type: "SITIDATA"}})
				.catch(() => {});
		},
		goToConfig() {
			this.$router
				.push({name: "app-setting", params: {company_id: this.item.id, config_type: "LIST"}})
				.catch(() => {});
		},

		handleAccessToken() {
			this.$router.push({name: "session-api", params: {id: this.item.id, company: this.item}}).catch(() => {});
		},
	},
};
</script>

<style lang="scss" scoped>
.logo {
	width: 120px;
	height: auto;
}
</style>
